import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Toolbar from './Toolbar';
import Firebase from 'src/Firebase.js'
import TransferBarleyOutTableWrapper from './TransferBarleyOutTableWrapper';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));


const TransferBarleyOutListView = () => {
  const classes = useStyles();


  useEffect(() => {
    // Update the document title using the browser API

    
  });


  return (
    <Page
      className={classes.root}
      id="TransferBarleyOut"
      title="Transfer Barley Out"
    >
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
         <div id='fk121'>
          <TransferBarleyOutTableWrapper />
          </div>
          

        </Box>
      </Container>
    </Page>
  );
};

export default TransferBarleyOutListView;
